import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import getters from './getters'
import im from "./modules/im";
import product from './modules/product'
import pageCache from './modules/pageCache'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    im,
    product,
    pageCache
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js